import React, { useEffect, useState, useRef } from "react";
import { Toast } from "../../../Component/Toast";
import { get } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import CustomScroll from "../../../Component/CustomScroll";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";

const DrowStatus = () => {

    const location = useLocation();
    const scrollRef = useRef(null);

    const mockNotifications = [
        {
            title: "Payment received",
            message: "Client A paid invoice #1042",
            created_at: "2026-04-06 10:30:00", // today
        },
        {
            title: "Profile updated",
            message: "User Jane Smith changed contact email",
            created_at: "2026-04-06 08:12:45", // today
        },
        {
            title: "Document uploaded",
            message: "KYC document added by Client B",
            created_at: "2026-04-05 18:05:10", // yesterday
        },
        {
            title: "New booking",
            message: "Consultation scheduled for Apr 12",
            created_at: "2026-04-04 14:20:00", // other date
        },
        {
            title: "Reminder sent",
            message: "Payment reminder issued to Client C",
            created_at: "2026-03-30 09:00:00", // other date
        },

    ];


    useEffect(() => {
        const fromFooter = location.state?.fromFooter;

        if (fromFooter) {
            if (location.state?.fromFooter) {
                setTimeout(() => {
                    if (scrollRef.current) {
                        scrollRef.current.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                }, 0);
                getList();
            }
        }
    }, [location]);

    const [groupedData, setGroupedData] = useState({
        today: [],
        yesterday: [],
        others: {},
    });

    const formatDate = (dateStr) => {
        const parts = dateStr.split(" ");
        return parts[0]; // return YYYY-MM-DD
    };

    const groupNotifications = (list) => {
        const todayDate = new Date().toISOString().split("T")[0];
        console.log("todayDate", todayDate);
        const yesterdayDateObj = new Date();
        yesterdayDateObj.setDate(yesterdayDateObj.getDate() - 1);
        const yesterdayDate = yesterdayDateObj.toISOString().split("T")[0];
        console.log("yesterdayDate", yesterdayDate);
        const formattedyesterdayDate = moment(yesterdayDate).format("DD-MM-YYYY");
        console.log("formattedyesterdayDate", formattedyesterdayDate);

        let todayArr = [];
        let yesterdayArr = [];
        let otherGroups = {};

        list.forEach((item) => {
            const dateOnly = formatDate(item.created_at);


            const formatedDate = moment(todayDate).format("DD-MM-YYYY");
            console.log("formatedDate", formatedDate);
            if (dateOnly === formatedDate) {
                todayArr.push(item);
            } else if (dateOnly === formattedyesterdayDate) {
                yesterdayArr.push(item);
            } else {
                if (!otherGroups[dateOnly]) {
                    otherGroups[dateOnly] = [];
                }
                otherGroups[dateOnly].push(item);
            }
        });

        setGroupedData({
            today: todayArr,
            yesterday: yesterdayArr,
            others: otherGroups,
        });

    };

    const getList = async () => {
        try {
            const res = await get(URLS.DROWSTATUS);
            console.log("API data", res.data);
            if (res?.status === "success" && Array.isArray(res?.data)) {
                groupNotifications(res.data);
            }
        } catch (err) {
            Toast("Failed to load history");
        }
    };

    useEffect(() => {
        getList();
    }, []);

    console.log("groupedData", groupedData);

    const getOnlyTime = (dateTimeStr) => {
        if (!dateTimeStr) return "";
        const parts = dateTimeStr.split(" ");
        return parts.slice(1).join(" ");
    };

    const formatDisplayDate = (dateStr) => {
        const [year, month, day] = dateStr.split("-");
        return `${day}-${month}-${year}`;
    };



    return (
        <div style={{ width: '100%', paddingBottom: 60 }} className="dashRightView-foots">
            <CustomScroll ref={scrollRef}>
                <div style={{ marginBottom: -25, height: '90vh' }} className=" container_overalls">
                    {groupedData?.today?.length > 0 && (
                        <div className=" ">
                            <p className="f3 fs-xs-17 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 mb-1 primary1">
                                Today
                            </p>
                            {groupedData?.today?.map((item, ind) => {
                                return (
                                    <div className="calender-input-daily mb-2 p-3" key={ind}>
                                        {/* <h1 style={{ fontSize: 16 }} className="f4 fs-sm-16">{item?.title}</h1> */}
                                        <p className="f2 fs-xs-14 messageTxc fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 ">
                                            {item?.message}{" "}
                                        </p>
                                        <div className="d-flex ac-je mt-2">
                                            <p className="f2 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 gray">
                                                {item?.time}
                                            </p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                    {groupedData?.yesterday?.length > 0 && (
                        <div className="  ">
                            <p className="f3 mt-2 fs-xs-17 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 mb-1 primary1">
                                Yesterday
                            </p>
                            {groupedData?.yesterday?.map((item, ind) => {
                                return (
                                    <div className="calender-input-daily mb-4 p-3" key={ind}>
                                        {/* <h1 style={{ fontSize: 16 }} className="f4 fs-sm-16">{item?.title}</h1> */}
                                        <p className="f2 fs-xs-14 messageTxc fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 ">
                                            {item?.message}{" "}
                                        </p>
                                        <div className="d-flex ac-je mt-2">
                                            <p className="f2 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 gray">
                                                {item?.time}
                                            </p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {Object.keys(groupedData?.others)?.map((date, ind) => {
                        return (
                            <div className="  " key={ind}>
                                <p className="f3 mt-2 fs-xs-17 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 mb-1 fs-xxl-24 primary1">
                                    {date}
                                </p>
                                {groupedData?.others?.[date]?.map((item, subInd) => {
                                    return (
                                        <div className="calender-input-daily mb-4 p-3" key={subInd}>
                                            {/* <h1 style={{ fontSize: 16 }} className="f4 fs-sm-16">{item?.title}</h1> */}
                                            <p className="f2 fs-xs-14 fs-sm-16 fs-md-18 messageTxc fs-lg-20 fs-xl-22 fs-xxl-24 ">
                                                {item?.message}{" "}
                                            </p>
                                            <div className="d-flex ac-je mt-2">
                                                <p className="f2 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 gray">
                                                    {item?.time}
                                                </p>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}

                    {groupedData.today.length === 0 &&
                        groupedData.yesterday.length === 0 &&
                        Object.keys(groupedData.others).length === 0 && (
                            <div className="   mt-3">
                                <p className="f3 text-center fs-xs-17 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 primary">
                                    No data
                                </p>
                            </div>
                        )}
                </div>
            </CustomScroll>
        </div>
    );
};
export default DrowStatus;
